import { useEffect, useState } from "react";
import "./App.css";
import Register from "./components/Register";
import Record from "./components/Record";
import Search from "./components/Search";

function App() {
  const [location, setLocation] = useState("");
  const [path, setPath] = useState("");
  const [url, setUrl] = useState("");
  const [mode, setMode] = useState("");
  const [domain, setDomain] = useState("https://www.najumbnmarathon.kr");
  const [category, setCategory] = useState("");
  const [isInitialized, setInitialized] = useState(false);

  useEffect(() => {
    console.log("hello, i'm mounting");
    function handleReceiveMessage(event) {
      // if (event.origin !== "https://mbn-marathon.imweb.me") return;
      let forType = "";
      if (event.data.type === "locationResponse") {
        console.log("react: locationResponse...");
        const url = new URL(event.data.location);
        setUrl(url);
        const pathname = url.pathname.split("/")[1]; // Extracting the first part of the path after the leading '/'
        setPath(pathname);
        setLocation(event.data.location);
        setDomain(event.data.domain);
        getModeAndCategory(pathname);
        console.log("locationResponse, pathname: ", pathname);
        console.log("locationResponse, domain: ", event.data.domain);
        forType = "locationResponse";
      } else if (event.data.type === "initialize") {
        console.log("initialized");
        setInitialized(true);
        console.log("domain: ", event.data.domain);
        setDomain(event.data.domain);
        forType = "initialize";
      }

      event.source.postMessage(
        {
          type: "ack",
          forType: forType,
        },
        event.origin
      );
    }

    window.addEventListener("message", handleReceiveMessage, false);

    return () => {
      window.removeEventListener("message", handleReceiveMessage, false);
    };
  }, []);

  useEffect(() => {
    if (isInitialized) {
      window.parent.postMessage({ request: "getLocation" }, domain);
    }
  }, [isInitialized]);

  useEffect(() => {
    console.log("path: ", path);
  }, [path]);

  // useEffect(() => {
  //   sendHeightToParent();
  // }, [location, path, url]);

  const getModeAndCategory = (pathname) => {
    if (pathname === "indiv") {
      setCategory("individual");
    } else if (pathname === "team") {
      setCategory("group");
    } else if (pathname === "competition") {
      setCategory("club");
    } else if (pathname === "indiv-check") {
      setCategory("individual");
    } else if (pathname === "team-check") {
      setCategory("group");
    } else if (pathname === "competition-check") {
      setCategory("club");
    }
  };

  return (
    <Container path={path} url={url} category={category} domain={domain} />
  );
}

export default App;

const Container = ({ path, url, category, domain }) => {
  if (path && path.includes("-check")) {
    return <Search category={category} domain={domain} />;
  } else if (path) {
    return <Register url={url} category={category} domain={domain} />;
  } else {
    return <p className="header">{domain}</p>;
  }
};
